<template>
  <div>
    <div class="blank-slate-pf text-center">
      <div class="blank-slate-pf-icon">
        <span class="pficon pficon pficon-add-circle-o"></span>
      </div>
      <h1>
        {{ $t('notFound.title') }}
      </h1>
      <p>
        {{ $t('notFound.message') }}
      </p>
      <p>
        {{ $t('notFound.knowMore') }}
        <a href="#">
          {{ $t('notFound.clickHere') }}
        </a>
      </p>
      <div class="blank-slate-pf-main-action">
        <button @click="goBack" class="btn btn-primary btn-lg">
          {{ $t('notFound.back') }}
        </button>
      </div>
      <div class="blank-slate-pf-secondary-action">
        <button class="btn btn-default">Secondary Action</button>
        <button class="btn btn-default">Secondary Action</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/not-found/index.vue